module.exports = __webpack_public_path__ + "media/images/about/ac_8-3e8ae807fb3eb0c84b23be7bc1f3069f.jpg";